// extracted by mini-css-extract-plugin
export default {"root":"kLiHMbr9hTWsfkja9MsC","wrap":"z2x1ow7xzxGSd_8X8Aj2","modal":"B7ArVdxobGTDlID8iB3A","header":"PEAMkVx1p7z2SWi5AvQx"};